import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragmentDoc } from './order-guide-restaurant-collection-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetSalesPortalOrderGuideItemsDocument = gql`
  query getSalesPortalOrderGuideItems(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $collectionUUID: uuid!
  ) {
    getSalesPortalOrderGuideItems(
      collection_id: $collectionUUID
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_guide_item_id
      order_guide_item_partition_id
      variant_pack_id
      entry_info {
        par_level
        sort_order
      }
      pack_info {
        external_item_id
        max_unit_size
        min_unit_size
        unit
      }
      item_info {
        image_url
        item_id
        name
      }
    }
    order_guide_restaurant_collection(
      where: { uuid: { _eq: $collectionUUID } }
    ) {
      ...SalesPortalOrderGuides_OrderGuideRestaurantCollectionFields
    }
    order_guide_supplier_collection(where: { uuid: { _eq: $collectionUUID } }) {
      is_default
      name
      order_guide_supplier_partitions(
        order_by: [{ sort_order: asc_nulls_last }, { name: asc_nulls_last }]
      ) {
        is_default
        name
        sort_order
        uuid
      }
      uuid
    }
  }
  ${SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragmentDoc}
`;
export function useGetSalesPortalOrderGuideItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >(GetSalesPortalOrderGuideItemsDocument, options);
}
export function useGetSalesPortalOrderGuideItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >(GetSalesPortalOrderGuideItemsDocument, options);
}
export type GetSalesPortalOrderGuideItemsQueryHookResult = ReturnType<
  typeof useGetSalesPortalOrderGuideItemsQuery
>;
export type GetSalesPortalOrderGuideItemsLazyQueryHookResult = ReturnType<
  typeof useGetSalesPortalOrderGuideItemsLazyQuery
>;
export type GetSalesPortalOrderGuideItemsQueryResult = Apollo.QueryResult<
  Types.GetSalesPortalOrderGuideItemsQuery,
  Types.GetSalesPortalOrderGuideItemsQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetSalesPortalOrderGuideItemsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetSalesPortalOrderGuideItemsQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >(GetSalesPortalOrderGuideItemsDocument, options);
}

/**
 * Wrapped version of useGeneratedGetSalesPortalOrderGuideItemsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetSalesPortalOrderGuideItemsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetSalesPortalOrderGuideItemsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetSalesPortalOrderGuideItemsQuery,
    Types.GetSalesPortalOrderGuideItemsQueryVariables
  >(GetSalesPortalOrderGuideItemsDocument, lazyOptions);
}
